import request from '@/utils/request'

let CameraApi = {

  /*摄像头列表*/
  list(data) {
    return request._post('/shop/plus.camera.Index/index', data);
},
/*添加摄像头*/
add(data) {
    return request._post('/shop/plus.camera.Index/add', data);
},
/*修改摄像头*/
edit(data) {
    return request._post('/shop/plus.camera.Index/edit', data);
},
/*删除摄像头*/
del(data) {
    return request._post('/shop/plus.camera.Index/del', data);
},
/*摄像头详情*/
detail(data) {
  return request._post('/shop/plus.camera.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.camera.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.camera.Setting/getSetting', data, errorback);
    },
}
export default CameraApi;



// WEBPACK FOOTER //
// ./src/api/camera.js